// extracted by mini-css-extract-plugin
export default {"container":"smallAvatar_container__J7fV-","imageBox":"smallAvatar_imageBox__3fN9I"};